export enum WebIntegrationType {
    FEIM = 'feim',
    BGI = 'bgi',
}

export enum WebIntegrationErrorCodes {
    GENERAL_UI_BOUNDARY = 8053,
    INVALID_TOKEN = 2000,
    FAILED_ERROR = 3000,
    BGI_BALANCE = 3003,
    BG_LOSS_LIMIT = 3001,
    BGI_INVALID_AUTH = 2010,
}
